export const PLATFORM_BILLING_TERMS_VERSION =
  "paxom-service-agreement-12m-v1";

export const PLATFORM_BILLING_AGREEMENT_PDF_HREF =
  `/platform-contracts/${PLATFORM_BILLING_TERMS_VERSION}.pdf`;

export const PLATFORM_BILLING_AGREEMENT_PDF_FILENAME =
  `${PLATFORM_BILLING_TERMS_VERSION}.pdf`;

export const PLATFORM_BILLING_CLICKWRAP_ACCEPTANCE_LABEL =
  "I am authorized to bind this business, and I agree to the 12-month Paxom service terms shown above, including monthly ACH billing.";

export const PLATFORM_BILLING_FROM_EMAIL =
  "Paxom <noreply@updates.paxom.ai>";

export const PLATFORM_BILLING_REPLY_TO_EMAIL = "privacy@paxom.ai";

export const PLATFORM_BILLING_LEGAL_ENTITY = "GKP LLC dba Paxom";

export const PLATFORM_BILLING_LEGAL_NOTICE_ADDRESS =
  "12656 Southern Highlands Pkwy, Las Vegas, NV 89141";

export const PLATFORM_BILLING_SITE_URL = "https://paxom.ai";

export const PLATFORM_BILLING_PRIVACY_URL = "https://paxom.ai/privacy";

export function platformBillingReadyHeadline(businessName: string) {
  return `${businessName} is ready`;
}

export function platformBillingAuthorizeCta(businessName: string) {
  return `Authorize ${businessName}`;
}
